import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray } from '@angular/forms';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { GradeService } from '../_services/grades.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { Subscription } from 'rxjs';
import { AmplitudeService } from 'src/app/_services/amplitude.service';
import { TimeZoneService } from 'src/app/_services/time-zone.service';
import { SelectSearchFilter } from 'src/app/shared/select-search-filter';
declare var $: any;

@Component({
  selector: 'app-add-grade',
  templateUrl: './add-grade.component.html',
  styleUrls: ['./add-grade.component.scss']
})
export class AddGradeComponent implements OnInit , OnDestroy {
  @Output() gradesScrollPosition = new EventEmitter();
  gradeId;
  gradeIndex:number;
  formFlag;
  state;
  addGradeForm: UntypedFormGroup;
  supervisors = [];
  gates = [];
  teachers = [];
  schoolClasses = [];
  currLang;
  closedDay;
  daysOfWeak = [];
  singleTime;
  singleBufferTime = 0;
  multipleTimeFlag: boolean = false;
  school_closing_time;
  invalidFormFlag:boolean = false;
  single_time_error:boolean = false;
  errorsArray:any = {};
  errorsFlag:boolean = false;
  gradesSub = new Subscription();
  showNotificationModal:boolean = false;
  showDismissalAlert:boolean = true;
  gateSearch = new SelectSearchFilter<any>('name');
  supervisorSearch = new SelectSearchFilter<any>(['name', 'national_id'], { placeholderKey: 'search-filter.search-by-name-or-id' });
  teacherSearch = new SelectSearchFilter<any>(['name', 'national_id'], { placeholderKey: 'search-filter.search-by-name-or-id' });
  // isScrollAllowed:boolean = 
  // startPickupTimeError;
  constructor(private dataService: DataService,
    private snackBarService: SnackbarService,
    private _snackBar: MatSnackBar,
    private globalService: GlobalService,
    private translate: TranslateService,
    private errorMsgService: ErrorMsgService,
    private gradesService: GradeService,
    private amplitudesService: AmplitudeService,
    private timeZoneService:TimeZoneService ) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    $('.mutliple-times').hide();
    $(document).on('hidden.bs.modal', '#addGradeModal', () => {
      this.cancelModalHandler(false);
      $('.mutliple-times').hide();

    })
    this.dataService.getSchoolInfo().subscribe(res=>{
      let selectedSchool;
      selectedSchool = res.find(school=> school.selected == true);
      this.school_closing_time = this.timeZoneService.convertToLocalTime(selectedSchool.school_closing_time , "HH:mm:ss" , "HH:mm:ss");
    })
    this.formFlag = 'add';
    this.translate.get('init').subscribe(res => {
      this.state = this.translate.instant('grades-classes.add-grade-modal.add');
      // to initialize the days of weak array 
      this.daysFields();
    });
    this.translate.onLangChange.subscribe(res => {
      this.state = this.translate.instant('grades-classes.add-grade-modal.add');
      // this.startPickupTimeError="";
      // to initialize the days of weak array on lang change to update days names 
      this.daysFields();
    })

    this.dataService.getSupervisors().subscribe((res: any) => {
      this.supervisors = res;
      this.supervisorSearch.setSource(this.supervisors);
    })
    this.dataService.getAllGates().subscribe((res: any) => {
      this.gates = res;
      this.gateSearch.setSource(this.gates);
    })

    this.dataService.getTeachers().subscribe((res: any) => {
      this.teachers = res;
      this.teacherSearch.setSource(this.teachers);
    })
    this.addGradeForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('^[\a-zA-z0-9-_\u0621-\u064A\u0660-\u0669 ]+$')]),
      supervisors_ids: new UntypedFormControl(''),
      gates_ids: new UntypedFormControl(''),
      // pickup_start_time: new FormControl(''),
      is_special_time_enabled: new UntypedFormControl(''),
      is_start_time_buffer_enabled: new UntypedFormControl(''),
      classes_names: new UntypedFormArray([
        // new FormControl('', [Validators.pattern('^[\a-zA-z0-9-_\u0621-\u064A\u0660-\u0669 ]+$')])
      ]),
      teachers_ids: new UntypedFormArray([
        // new FormControl('')
      ]),
      // students_can_self_checkout:new UntypedFormControl(false)
    })

    // edit grade
    this.gradesSub = this.gradesService.getGradeData().subscribe((res: any) => {
      if (res) {
        this.dataService.getTeachers().subscribe((res: any) => {
          this.teachers = res;
          this.teacherSearch.setSource(this.teachers);
        })
        this.formFlag = 'edit';
        this.translate.get('init').subscribe(res => {
          this.state = this.translate.instant('grades-classes.add-grade-modal.edit');
        });
        this.translate.onLangChange.subscribe(res => {
          this.state = this.translate.instant('grades-classes.add-grade-modal.edit');
        });
        this.gradeId = res.id;
        this.gradeIndex = this.gradeId
        this.schoolClasses = res.school_classes;
        this.addGradeForm.controls['name'].setValue(res.name);
        this.addGradeForm.controls['is_special_time_enabled'].setValue(res.is_special_time_enabled);
        this.addGradeForm.controls['is_start_time_buffer_enabled'].setValue(res.is_start_time_buffer_enabled);
        // this.addGradeForm.controls['students_can_self_checkout'].setValue(res.students_can_self_checkout == 1 ? true:false);
        // this.addGradeForm.controls['pickup_start_time'].setValue(res.pickup_start_time);
        this.addGradeForm.controls['supervisors_ids'].setValue(res.supervisors.map(supervisor => {
          return supervisor.id
        }));
        if (res.gates.length > 0) {
          this.addGradeForm.controls['gates_ids'].setValue(res.gates[0].id);
        }
        if (res.school_classes.length > 0) {
          while (this.classes_names.length !== 0) {
            this.classes_names.removeAt(0)
          }
          for (let x = 0; x < res.school_classes.length; x++) {
            this.addClassField();
            this.addTeacherField();
          }
          for (let x = 0; x < res.school_classes.length; x++) {
            this.classes_names.controls[x].setValue(res.school_classes[x].name);
            this.teachers_ids.controls[x].setValue(res.school_classes[x].teachers.map(teacher => {
              return teacher.id
            }))
          }
        }
        // to fill the fields of days of weak with the data of the grade to edit it 
        this.fillEditForm(res);
      }
    })
    $(document).on('shown.bs.modal', '#addGradeModal', () => {
      // if(this.formFlag == 'add'){
      //   this.gradeIndex = 0;
      // }
      this.toggleMatFieldWidth();
    })
  }


  // getters method
  get classes_names(): UntypedFormArray {
    return this.addGradeForm.get('classes_names') as UntypedFormArray;
  }
  get teachers_ids(): UntypedFormArray {
    return this.addGradeForm.get('teachers_ids') as UntypedFormArray;
  }
  // to get the value of the is_special_time_enabled key that we use to toggle the view in the template between on time or special time
  get is_special_time_enabled() { return this.addGradeForm.get('is_special_time_enabled').value; }
  // to get the value of the is_start_time_buffer_enabled key that we use to toggle buffer time
  get is_start_time_buffer_enabled() { return this.addGradeForm.get('is_start_time_buffer_enabled').value; }

  

  addClassTeacherRow() {
    this.addClassField();
    this.addTeacherField();
  }

  addClassField() {
    this.classes_names.push(new UntypedFormControl('', [Validators.required, Validators.pattern('^[\a-zA-z0-9-_\u0621-\u064A\u0660-\u0669 ]+$')]))
  }

  addTeacherField() {
    this.teachers_ids.push(new UntypedFormControl(''));
  }

  fillEditForm(res) {
    // the passed parameter "res" is the grade data from the getGradeData Observable 
    let selectedDay;
    /* here we need to update the daysOfWeak array with the time from the dismissal_schedule array from the "res" for each day,
    so we loop over the daysOfWeak array and for each day we find the day from the dismissal_schedule array that match the day
     of the daysOfWeak array, 
     then we update the day time and is_closed from the found values from the dismissal_schedule
     */
    if(res.dismissal_schedule.length > 0){
      if(res.is_special_time_enabled == false){
        /* in case is_special_time_enabled is false that means that the view is single time ,
        so we set the single time to the time of the first day from res*/
        this.singleTime = this.timeZoneService.convertToLocalTime(res.dismissal_schedule[0].start_time,"HH:mm" , "HH:mm");
        this.singleBufferTime = res.dismissal_schedule[0].start_time_buffer;
      }
      this.daysOfWeak.forEach(day => {
        selectedDay = res.dismissal_schedule.find(schedule => schedule.day_of_week == day.value);
        day.time = this.timeZoneService.convertToLocalTime(selectedDay.start_time,"HH:mm" , "HH:mm");
        day.is_closed = selectedDay.is_closed;
        day.buffer_time = selectedDay.start_time_buffer
      })
    }
  
  }
  removeClassTeacherRow(index: number) {
    // the user trying to delete the last row
    // if (this.classes_names.length === 1) {
    //   this.snackBarService.setSnackBarMessage(this.translate.instant('grades-classes.add-grade-modal.class-req-msg'));
    //   this._snackBar.openFromComponent(SnackBarErrorComponent, {
    //     duration: 5000,
    //     horizontalPosition: 'center',
    //     verticalPosition: 'top',
    //   });
    // }
    if (this.formFlag === 'edit' && this.schoolClasses[index] !== undefined && this.schoolClasses[index].students.length > 0) {
      this.snackBarService.setSnackBarMessage(this.translate.instant('grades-classes.add-grade-modal.students-class'));
      this._snackBar.openFromComponent(SnackBarErrorComponent, {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
    }
    else {
      if (this.formFlag === 'edit' && this.schoolClasses[index] !== undefined) {
        this.gradesService.deleteClass(this.schoolClasses[index].id).subscribe(res => {
          this.classes_names.removeAt(index);
          this.teachers_ids.removeAt(index);
          this.schoolClasses.splice(index, 1);
        }, (error) => {
          this.snackBarService.setSnackBarMessage(error.error.message);
          this._snackBar.openFromComponent(SnackBarErrorComponent, {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        })
      }
      else {
        this.classes_names.removeAt(index);
        this.teachers_ids.removeAt(index);
        this.schoolClasses.splice(index, 1);
      }
    }
  }

  initializeStartTimeArray() {
    let startTime = []
    if (this.addGradeForm.value['is_special_time_enabled'] == true) {
      startTime = []
      this.daysOfWeak.forEach(element => {
        startTime.push({
          day_of_week: element.value,
          start_time: this.timeZoneService.convertToSaudiTime(element.time, "HH:mm" , "HH:mm"),
          is_closed: element.is_closed,
          start_time_buffer:element.buffer_time ? element.buffer_time : 0
        })
      });
    }
    else {
      startTime = [];
      startTime.push({
        day_of_week: 'All',
        start_time: this.timeZoneService.convertToSaudiTime(this.singleTime, "HH:mm" , "HH:mm"),
        start_time_buffer : this.singleBufferTime ? this.singleBufferTime : 0
      })
    }

    return startTime
  }

  

  saveGrade(notifyParent:boolean) {
    // in cases of creating new grade
    let keys = ['name', 'supervisors_ids', 'gates_ids', 'pickup_start_time'];
    if (this.formFlag === 'add') {
      this.amplitudesService.trackEvent('Click.Save_Grade',{})
      let body: any = {}
      body.name = this.addGradeForm.value['name'];
      // check the is_special_time_enabled key if it's empty assign false to it else assing the value 
      body.is_special_time_enabled = this.addGradeForm.value['is_special_time_enabled'] ? this.addGradeForm.value['is_special_time_enabled'] : false;
      body.is_start_time_buffer_enabled = this.addGradeForm.value['is_start_time_buffer_enabled'] ? this.addGradeForm.value['is_start_time_buffer_enabled'] : false;
      // this function to get single time or special time 
      body.start_time_schedule = this.initializeStartTimeArray();
      if (this.addGradeForm.value['supervisors_ids']?.length > 0) {
        const visibleSupervisorIds = new Set(this.supervisors.map(s => s.id));
        body.supervisors_ids = this.addGradeForm.value['supervisors_ids']
          .filter(id => visibleSupervisorIds.has(id));
      }
      if (this.addGradeForm.value['gates_ids']) {
        body.gates_ids = this.addGradeForm.value['gates_ids'];
      }
      // body.students_can_self_checkout = this.addGradeForm.value['students_can_self_checkout'];
      body.notify_dismissal_changed = notifyParent;
      
      this.gradesService.createGrade(body).subscribe((res: any) => {
        this.gradeId = res.id
        this.gradeIndex = res.id;
        if (this.addGradeForm.value['classes_names'].length > 0) {
          let classes = [];
          this.addGradeForm.value['classes_names'].map((element, index) => {
            let classObject = {};
            classObject['name'] = element;
            classObject['grade_id'] = this.gradeId;
            const visibleTeacherIds = new Set(this.teachers.map(t => t.id));
            const selectedTeachers = this.addGradeForm.value['teachers_ids'][index];
            classObject['teachers_ids'] = selectedTeachers !== "" && Array.isArray(selectedTeachers)
              ? selectedTeachers.filter(id => visibleTeacherIds.has(id))
              : [];
            classes.push(classObject);
          })
          this.gradesService.createClass({ 'classes': classes }).subscribe((res: any) => {
          }, (err => { }), () => {
            this.showNotificationModal = false;
            this.dataService.updateGradesCache(5000);
          })
        }
        // this.dataService.allGrades.push(res)
        // this.dataService.setAllGrades$(this.dataService.allGrades)
        this.cancelModalHandler(true);
      }, err => {
        this.showNotificationModal = false;
        this.errorsArray = err.error.errors;
        if(Object.keys(this.errorsArray).length > 0){
          this.errorsFlag = true
        }
        else{
          this.errorsFlag = false
        }
        if(err.error.errors){
            if (err.error.errors.name){
            this.errorMsgService.setMessage(err.error.errors.name[0])
          }
        }
        else{
          this.errorMsgService.setMessage(err.error.message);
        }
    
        // this.startPickupTimeError=err.error.errors.pickup_start_time[0];
      }, () => {
        this.showNotificationModal = false;
        this.dataService.updateAllCache(5000);
      })
    }
    else {
      // the user is editing the grade
      this.amplitudesService.trackEvent('Click.Save_Grade_Edit',{})
      let body: any = {};
      for (const key of keys) {
        body[key] = this.addGradeForm.value[key];
      }
      body['gates_ids'] = [];
      if (this.addGradeForm.value['gates_ids']) {
        body['gates_ids'] = this.addGradeForm.value['gates_ids'];
      }

      body['supervisors_ids'] = [];
      if (this.addGradeForm.value['supervisors_ids']) {
        const visibleSupervisorIds = new Set(this.supervisors.map(s => s.id));
        body['supervisors_ids'] = this.addGradeForm.value['supervisors_ids']
          .filter(id => visibleSupervisorIds.has(id));
      }
      

      // if(this.addGradeForm.value['pickup_start_time']== '' || this.addGradeForm.value['pickup_start_time']== null){
      //   delete body['pickup_start_time']
      // }
      body.is_special_time_enabled = this.addGradeForm.value['is_special_time_enabled'] ? this.addGradeForm.value['is_special_time_enabled'] : false;
      body.is_start_time_buffer_enabled = this.addGradeForm.value['is_start_time_buffer_enabled'] ? this.addGradeForm.value['is_start_time_buffer_enabled'] : false;
      body.start_time_schedule = this.initializeStartTimeArray();
      body.notify_dismissal_changed = notifyParent;

      
      let classes = [];
      if (this.addGradeForm.value.classes_names.length > this.schoolClasses.length) {
        let newClassesToAdd = this.addGradeForm.value.classes_names.slice(this.schoolClasses.length);
        let newTeachersToAdd = this.addGradeForm.value.teachers_ids.slice(this.schoolClasses.length);
        newClassesToAdd.map((element, index) => {
          let classObject = {};
          classObject['name'] = element;
          classObject['grade_id'] = this.gradeId;
          if (newTeachersToAdd[index] !== '') {
            classObject['teachers_ids'] = newTeachersToAdd[index];
          }
          classes.push(classObject);
        })
        this.gradesService.createClass({ 'classes': classes }).subscribe((res: any) => {
        })
      }

      this.gradesService.updateGrade(body, this.gradeId).subscribe((res: any) => {
        if (this.schoolClasses.length > 0) {
          this.schoolClasses.map((clazz, index) => {
            const visibleTeacherIds = new Set(this.teachers.map(t => t.id));
            const selectedTeachers = this.addGradeForm.value['teachers_ids'][index];
            const filteredTeacherIds = Array.isArray(selectedTeachers)
              ? selectedTeachers.filter(id => visibleTeacherIds.has(id))
              : [];
            this.gradesService.updateClass({ name: this.addGradeForm.value['classes_names'][index], grade_id: this.gradeId, teachers_ids: filteredTeacherIds }, clazz.id)
              .subscribe(res => {
                this.cancelModalHandler(true);
              }, (err => { }), () => {
              })
          })
        }
        else {
          this.cancelModalHandler(true);
        }
        let gradeIndex = this.dataService.allGrades.findIndex((grade => grade.id == this.gradeId));
        this.dataService.allGrades[gradeIndex] = res;
        this.dataService.setAllGrades$(this.dataService.allGrades)
      }, err => {
        this.showNotificationModal = false;
        this.errorsArray = err.error.errors;
        if(Object.keys(this.errorsArray).length > 0){
          this.errorsFlag = true
        }
        else{
          this.errorsFlag = false
        }
        if (err.error.errors) {
          if (err.error.errors.name){
            this.errorMsgService.setMessage(err.error.errors.name[0])
          }
        }

        else if (err.error.message) {
          this.errorMsgService.setMessage(err.error.message);
        }


        // this.startPickupTimeError=err.error.errors.pickup_start_time[0];
      }, () => {
        this.showNotificationModal = false;
        // Update specific grade and all gates cache using centralized method
        this.dataService.updateGradesByIdAndAllGates([this.gradeId], 3000);
      })
    }
  }

  cancelModalHandler(reload:boolean) {
    this.formFlag = 'add';
    this.translate.get('init').subscribe(res => {
      this.state = this.translate.instant('grades-classes.add-grade-modal.add');
    });
    this.translate.onLangChange.subscribe(res => {
      this.state = this.translate.instant('grades-classes.add-grade-modal.add');
    })
    this.addGradeForm.reset();
    this.classes_names.clear();
    this.teachers_ids.clear();
    // this.addGradeForm.controls['students_can_self_checkout'].setValue(false);
    // this.classes_names.push(new FormControl(''));
    // this.teachers_ids.push(new FormControl(''))
    // to reset single time or multiple times when modal is closed
    this.singleTime = "";
    this.resetAllDays();
    this.resetBufferTime();
    this.gateSearch.reset();
    this.supervisorSearch.reset();
    this.teacherSearch.reset();
    if(reload){
      this.gradesService.setGradesReload();
      this.gradesScrollPosition.emit(this.gradeIndex);
    }
    this.gradesService.setGradeData(null);    
    $("#addGradeModal").modal("hide");
  }

  getGradeFormValidation(control: string) {
    let errorMSG;
    if (this.addGradeForm.controls[control].errors) {
      errorMSG = this.addGradeForm.controls[control].errors.required ? this.translate.instant('grades-classes.add-grade-modal.grade-required') :
        this.addGradeForm.controls[control].errors.maxlength ?
          this.translate.instant('grades-classes.add-grade-modal.grade-length') :
          this.translate.instant('grades-classes.add-grade-modal.grade-valid');
    }
    return errorMSG;
  }

  getClassValidation(control) {
    let errorMsg;
    if (control.errors) {
      errorMsg = control.errors.required ? this.translate.instant('grades-classes.add-grade-modal.class-required') : this.translate.instant('grades-classes.add-grade-modal.class-valid');
    }
    return errorMsg
  }

  toggleMultibleView(e) {
    // to toggle the view between on time and multiple special times 
    if (e.target.checked) {
    // to reset single time in case checkbox is checked , to enter multiple times only 
      this.singleTime = "";
      this.single_time_error = false;
      this.resetErrorsArray();
      this.addGradeForm.controls['is_special_time_enabled'].setValue(true);
    }
    else {
      this.addGradeForm.controls['is_special_time_enabled'].setValue(false);
      // to reset multiple times in case checkbox is unchecked , to enter single time only 
      this.resetAllDays();
    }

    this.toggleMatFieldWidth();
    // this.resetBufferTime();
  }

  toggleMatFieldWidth(){
    const root = document.documentElement;
    if(this.currLang == 'ar' && this.is_special_time_enabled && this.is_start_time_buffer_enabled){
      root.style.setProperty('--width', ' 35.6406px');
    }
    else if(this.currLang == 'ar' && this.is_special_time_enabled && !this.is_start_time_buffer_enabled){
      root.style.setProperty('--width', ' 248px');
    }

  }
  toggleBufferTime(e) {
    if (e.target.checked) {
      this.addGradeForm.controls['is_start_time_buffer_enabled'].setValue(true);

    }
    else {
      this.addGradeForm.controls['is_start_time_buffer_enabled'].setValue(false);
      this.resetBufferTime();

    }
    this.toggleMatFieldWidth();
  }

  toggleDayClosed(e) {
    // toggle disabled class on the field that only change the bg-color to grey
    $(`#${e.value}Overlay`).toggleClass('disabled');
    // toggle attribute readonlyonly on the input to remove the stopwatch icon and disaple the functionality
    $(`#${e.value}Input`).attr('readonly', (_, attr) => !attr);
    // toggle attribute disabled  on the input to remove the time placeholder
    $(`#${e.value}Input`).attr('disabled', (_, attr) => !attr);
    // toggle disabled_buffer class on the buffer time field that only change the bg-color to grey
    $(`#${e.value}BufferInput`).toggleClass('disabled_buffer');
    // reset time buffer field value if day is closed
    if(e.is_closed){
      $(`#${e.value}BufferInput`).val(0);
    }
    let selectedDay;
    // to find the selected day and reset it's time on toggle
    selectedDay = this.daysOfWeak.find(day => day.value == e.value);
    selectedDay.time = '';
    selectedDay.is_error = false;
    selectedDay.is_closed = !selectedDay.is_closed;
    this.daysOfWeak.some(day => day.is_error == true)?this.invalidFormFlag = true : this.invalidFormFlag = false
    this.resetErrorsArray();
  }

  resetStartingTime() {
    // check the value of ending time field , if it's empty reset it again so the field reset in the view  
    if ($("#schoolStart").val() == '') {
      $("#schoolStart").val('')
    }
  }
  daysFields() {
    // the input key for the input id 
    // the overlay key is for the overlay div id , this div is used to toggle a grey background color
    this.daysOfWeak = [
      { name: 'grades-classes.add-grade-modal.sun', value: 'Sunday', time: '', buffer_time:0, input: 'SundayInput', buffer_input:'SundayBufferInput', overlay: 'SundayOverlay', is_closed: false , is_error:false },
      { name: 'grades-classes.add-grade-modal.mon', value: 'Monday', time: '', buffer_time:0, input: 'MondayInput', buffer_input:'MondayBufferInput',overlay: 'MondayOverlay', is_closed: false , is_error:false},
      { name: 'grades-classes.add-grade-modal.tue', value: 'Tuesday', time: '',buffer_time:0, input: 'TuesdayInput',buffer_input:'TuesdayBufferInput', overlay: 'TuesdayOverlay', is_closed: false , is_error:false },
      { name: 'grades-classes.add-grade-modal.wed', value: 'Wednesday', time: '',buffer_time:0, input: 'WednesdayInput',buffer_input:'WednesdayBufferInput', overlay: 'WednesdayOverlay', is_closed: false , is_error:false},
      { name: 'grades-classes.add-grade-modal.thu', value: 'Thursday', time: '',buffer_time:0, input: 'ThursdayInput',buffer_input:'ThursdayBufferInput', overlay: 'ThursdayOverlay', is_closed: false , is_error:false },
      { name: 'grades-classes.add-grade-modal.fri', value: 'Friday', time: '',buffer_time:0, input: 'FridayInput',buffer_input:'FridayBufferInput', overlay: 'FridayOverlay', is_closed: false , is_error:false},
      { name: 'grades-classes.add-grade-modal.sat', value: 'Saturday', time: '',buffer_time:0, input: 'SaturdayInput', buffer_input:'SaturdayBufferInput', overlay: 'SaturdayOverlay', is_closed: false , is_error:false}
    ]
  }

  resetAllDays() {
    this.daysOfWeak.forEach(day => {
      day.time = '';
      day.is_closed = false;
      day.is_error = false;
    })
    this.resetErrorsArray();
  }

  resetBufferTime(){
    this.daysOfWeak.forEach(day => {
      day.buffer_time = 0;
    })
    this.singleBufferTime = 0;

    // if(this.is_special_time_enabled){
    
    // }
    // else {
    // }
   
  }

  getError(event){
    this.resetErrorsArray();
    if(event.target.id == "SingleInput"){
      if(event.target.value > this.school_closing_time){
        // toggle single_time_error of this single time 
        this.single_time_error = true;
      }
      else{
        this.single_time_error = false;
      }
    }
    else{
      // find selected day from daysofWeak array 
    let selectedDay = this.daysOfWeak.find(day=> day.input == event.target.id)
    // check if the entered time on every change of each day is bigger than the school ending time 
     if(event.target.value > this.school_closing_time){
       // toggle is_error of this selected day
       selectedDay.is_error = true;
     }
     else{
       selectedDay.is_error = false;
     }
     /* check if at least one of the days in the daysOfWeak array
     has a true value of is_error key that means on time is invalid 
     so toggle the form validation flag to true
     */ 
     this.daysOfWeak.some(day => day.is_error == true)?this.invalidFormFlag = true : this.invalidFormFlag = false    
    }
    
  }
  resetErrorsArray(){
    this.errorsFlag = false;
    this.errorsArray = {};
  }
  ngOnDestroy() {
    this.gradesSub.unsubscribe();
    this.gateSearch.destroy();
    this.supervisorSearch.destroy();
    this.teacherSearch.destroy();
  }

  validateInputNumber(event){
    const el = event.target
    if(el.type == "number" && el.max && el.min ){
      let value = parseInt(el.value)
      el.value = value // for 000 like input cleanup to 0
      let max = parseInt(el.max)
      let min = parseInt(el.min)      
      if ( value > max ) el.value = el.max
      if ( value < min ) el.value = el.min
      if ( el.value =="" || el.value == null || el.value == undefined || Number.isNaN(el.value)){
        el.value = el.min;
      } 
    }
  }

  showNotifyParentModal(){
    this.showNotificationModal = true;
  }

  closeModal(){
    this.showNotificationModal = false;
  }
}
